
const baseUrl = process.env.REACT_APP_BASE_URL;
const token = localStorage.getItem('token');

class UserService {

    

    createUser(name, address, username, password, countryId, groupId, branchId){

       

        const companyId = 1;

        const reqData = {
            'name': name,
            'username': username,
            'password': password,
            'address' : address,
            'countryId': countryId,
            'companyId' : companyId,
            'groupId' : groupId,
            'branchId' : branchId
        }; 

        return fetch(baseUrl+'/manager/user/create', {
            method : 'POST',
            headers: {

                'Content-Type' : 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization' : token,
                'Accept' : 'application/json',
            },
            body: JSON.stringify(reqData)
        });
    }

    userList(searchTerm,countryId){

        

        const reqData = {
            'searchTerm': searchTerm,
            
            'countryId': countryId
           
        }; 

        return fetch(baseUrl+'/manager/user/list', {
            method : 'POST',
            headers: {

                'Content-Type' : 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization' : token,
                'Accept' : 'application/json',
            },
            body: JSON.stringify(reqData)
        });
    }    

    fetchUser(userId){

        

        
        return fetch(baseUrl+'/manager/user/fetch/'+userId, {
            method : 'GET',
            headers: {

                'Content-Type' : 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization' : token,
                'Accept' : 'application/json',
            }
        });
    }
    
    updateUser(userId, name, address, username, password, countryId, groupId, branchId){

       

        const reqData = {
            'userId' : userId,
            'name': name,
            'username': username,
            'password': password,
            'address' : address,
            'countryId': countryId,
            'groupId': groupId,
            'branchId' : branchId
            
        }; 

        return fetch(baseUrl+'/manager/user/update', {
            method : 'PUT',
            headers: {

                'Content-Type' : 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization' : token,
                'Accept' : 'application/json',
            },
            body: JSON.stringify(reqData)
        });
    }

    isAuthorized(accessLevel){

        

        
        return fetch(baseUrl+'/authorized/'+accessLevel, {
            method : 'GET',
            headers: {

                'Content-Type' : 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization' : token,
                'Accept' : 'application/json',
            }
        });
    }

    roles(){

        

        
        return fetch(baseUrl+'/manager/user/role/list/', {
            method : 'GET',
            headers: {

                'Content-Type' : 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization' : token,
                'Accept' : 'application/json',
            }
        });
    }

    

    updateRole(userId, roleId){

        

        const reqData = {
            'userId' : userId,
            'roleId': roleId    
        }; 

        
        return fetch(baseUrl+'/manager/user/role/update', {
            method : 'PUT',
            headers: {

                'Content-Type' : 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization' : token,
                'Accept' : 'application/json',
            },
            body: JSON.stringify(reqData)
        });
    }


    groups(){

        

        
        return fetch(baseUrl+'/manager/user/group/list/', {
            method : 'GET',
            headers: {

                'Content-Type' : 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization' : token,
                'Accept' : 'application/json',
            }
        });
    }

    restrictions() {
   

    return fetch(baseUrl + '/manager/restriction/list', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': token,
            'Accept': 'application/json',
        }
    });
}

userRestrictions(userId) {

    return fetch(baseUrl + '/manager/restriction/user/' + userId, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': token,
            'Accept': 'application/json',
        }
    });
}

assignRestriction(userId, restrictionId) {

    return fetch(baseUrl + '/manager/restriction/assign', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': token,
            'Accept': 'application/json',
        },
        body: JSON.stringify({
            userId: userId,
            restrictionId: restrictionId
        })
    });
}

removeUserRestriction(userRestrictionId) {

    return fetch(baseUrl + '/manager/restriction/user-restriction/' + userRestrictionId, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': token,
            'Accept': 'application/json',
        }
    });
}


updateUserRestricted(userId, restricted) {
    

    return fetch(baseUrl + '/manager/user/restricted/' + userId, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': token,
            'Accept': 'application/json',
        },
        body: JSON.stringify({
            restricted: restricted
        })
    });
}


    




    
}

export default UserService;